import { getDataFromStore } from "../store/store";
const reducerNameApp = "app";
export const checkUserPermissions = (permissionName) => {
  var result = false;
  const userPermissions = getDataFromStore(reducerNameApp, "userPermissions");
  result = userPermissions.includes(permissionName);
  return result;
};
